<template>
  <el-container
    class="app-wrapper"
    :class="{'app-wrapper-vod': envType === 'VOD'}"
    v-loading="loading"
    element-loading-text="Loading"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.7)"
  >
    <el-header>
      <cs-header
        :userName="userInfo.nickname"
        :height="headerHeight"
        :dropdownList="dropdownList"
        :logo="img"
        :avatarUrl="userInfo.logo"
        fit="contain"
        @command="handleCommand"
      >
        <div class="fleft close-flod" @click="flodSwitch">
          <i :class="{ 'icon-baise-spread': isShowNav, 'icon-baise-daohangyincang': !isShowNav }"></i>
        </div>
        <div class="fright merchants">
          <template v-if="userType == 'admin'">
            <label>用户：</label>
            <el-select
              v-model="value"
              placeholder="请选择"
              @change="handleChange"
            >
              <el-option
                v-for="item in options"
                :key="item.userId"
                :label="item.name"
                :value="item.userId">
              </el-option>
            </el-select>
          </template>
          <span class="merchants-name" @click="goConsole">
          <i :class="merchants.icon"></i> {{merchants.label}}
        </span>
        </div>
      </cs-header>
    </el-header>
    <el-container class="main-wrapper">
      <el-aside :width="`${asideWith}px`" v-show="isShowNav">
        <cs-nav-menu
          :logoTitle="envType == 'VOD' ? title : ''"
          :collapse="false"
          :default-active="key"
          :menuItems="menuList"
        >
          <div class="header-upload" slot="nav-header" v-if="envType == 'CP'">
            <el-button type="primary" size="small" @click="uploadFile"><i class="el-icon-upload2"></i> 客户端上传</el-button>
          </div>

          <div class="header-upload" slot="nav-header" v-if="envType == 'UGC'">
            <el-button type="primary" size="small" @click="uploadFile"><i class="icon-toudi"></i> 投稿</el-button>
          </div>

        </cs-nav-menu>
      </el-aside>
      <el-main
        :class="{'tab-container': openTabs, 'bread-container': !openTabs && openBreadcrumb }"
      >
        <el-container>
          <el-header class="tab-header" v-if="isShowTabs" style="height: auto;">
            <tab-list
              v-if="openTabs"
              :carsList="tabList"
              :activeName="activeName"
              @activeTab="activeTabHandler"
              @tabRemove="tabRemoveHandler"
            />
            <bread-crumb
              :data="breadCrumbList"
              v-if="openBreadcrumb && breadCrumbList.length>1"
            />
          </el-header>
          <el-main class="app-main">
            <transition name="fade-transform" mode="out-in">
              <router-view v-if="isRouterAlive" :key="key" :perTree="perTree" />
            </transition>
          </el-main>
        </el-container>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { mapGetters } from 'vuex'
import { asideWith, headerHeight, isShowTabs, openTabs, openBreadcrumb } from '@/settings'
import TabList from './components/tabList'
import BreadCrumb from './components/breadCrumb'
import { logout, getBusinessAccount } from '@/resource/api'
import logoUrl from '@/assets/logo3x.png'
import logoOpenUrl from '@/assets/logo_open.png'
export default {
  name: 'Layout',
  components: {
    TabList,
    BreadCrumb
  },
  computed: {
    ...mapGetters([
      'menuList',
      'tabList',
      'breadCrumbList',
      'userInfo',
      'userType',
      'perTree'
    ]),
    key () {
      return this.$route.path
    },
    title () {
      switch (process.env.VUE_APP_NODE_ENV) {
        case 'CP':
          return '版权内容合作'
        case 'UGC':
          return '自媒体服务'
        case 'VOD':
          return '视频点播平台'
        default:
          return '媒资系统'
      }
    },
    envType () {
      return process.env.VUE_APP_NODE_ENV
    },
    img () {
      return process.env.VUE_APP_NODE_ENV == 'VOD' ? logoOpenUrl : logoUrl
    }
  },
  watch: {
    key (curVal, oldVal) {
      if (this.$route.meta.breadCrumb) {
        this.activeName = oldVal
      } else {
        this.activeName = curVal
      }
    }
  },
  data () {
    return {
      loading: false,
      asideWith,
      headerHeight,
      isShowTabs,
      openTabs,
      openBreadcrumb,
      isRouterAlive: false,
      isShowNav: true,
      activeName: this.$route.path,
      avatarUrl: '',
      dropdownList: [{
        title: '用户信息',
        icon: 'el-icon-user',
        command: 'userInfo'
      }, {
        title: '退出',
        icon: 'el-icon-switch-button',
        command: 'quit'
      }],
      merchants: {
        value: '1',
        icon: 'el-icon-s-home',
        label: '前往控制台'
      },
      value: '',
      options: []
    }
  },
  created () {
    // 增加页面刷新时 store 数据的持久化存储
    if (sessionStorage.getItem('store')) {
      this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(sessionStorage.getItem('store'))))
      sessionStorage.removeItem('store')
    }
    window.addEventListener('beforeunload', () => {
      sessionStorage.setItem('store', JSON.stringify(this.$store.state))
    })
    this.init()
  },
  methods: {
    reload () {
      this.isRouterAlive = false
      this.$nextTick(() => {
        this.isRouterAlive = true
      })
    },
    init () {
      if (this.userType == 'admin') {
        getBusinessAccount().then((res) => {
          this.options = res.data || []
          this.value = this.options[0] && this.options[0].userId
          this.$store.dispatch('setBusinessAccount', this.options[0])
          this.isRouterAlive = true
        }).catch(e => {
          console.error(e)
          this.options = []
          this.isRouterAlive = true
        })
      } else {
        this.isRouterAlive = true
      }
    },
    uploadFile () {
      if (this.envType === 'CP') {
        this.$router.push({ name: 'uploadVideo' })
      }
      if (this.envType === 'UGC') {
        this.$router.push({ path: '/uploadFile' })
      }
    },
    flodSwitch () {
      this.isShowNav = !this.isShowNav
    },
    activeTabHandler (tab) {
      this.$router.push({ path: tab.name })
    },
    tabRemoveHandler (targetName) {
      const tabs = this.tabList
      const activeName = this.activeName
      console.log(tabs)
      console.log(activeName)
      if (activeName === targetName) {
        tabs.forEach((tab, index) => {
          if (tab.path === targetName) {
            const nextTab = tabs[index + 1] || tabs[index - 1]
            if (nextTab) {
              this.$router.push({ path: nextTab.path })
            }
          }
        })
      }
      this.$store.dispatch('RemoveTab', targetName)
    },
    handleCommand (command) {
      switch (command) {
        case 'quit':
          this.logout()
          break
        case 'userInfo':
          this.checkUserInfo()
          break
      }
    },
    handleChange (value) {
      this.$store.dispatch('setBusinessAccount', this.options.filter(item => item.userId === value)[0])
      this.reload()
    },
    logout () {
      logout().then(res => {
        const that = this
        if (res.errorCode == '401' || res.code == '401') {
          this.loading = true
          const aIframe = document.createElement('iframe')
          aIframe.setAttribute('style', 'display: none')
          aIframe.setAttribute('src', res.redirect_url)
          document.body.appendChild(aIframe)
          if (aIframe.attachEvent) {
            aIframe.attachEvent('onload', function () { // IE
              that.goHomePage()
            })
          } else {
            aIframe.onload = function () { // 非IE
              that.goHomePage()
            }
          }
        }
      })
    },
    goHomePage () {
      if (this.envType === 'VOD') {
        // 判断是否为测试环境
        if (window.location.href.includes('stage-')) {
          window.location.href = 'http://stage-open.cloud.ottcn.com'
        } else {
          window.location.href = 'https://open.cloud.ottcn.com'
        }
      } else {
        // 判断是否为测试环境
        if (window.location.href.includes('stage-')) {
          window.location.href = 'http://stage-mp.cloud.ottcn.com'
        } else {
          window.location.href = 'https://mp.cloud.ottcn.com'
        }
      }
    },
    checkUserInfo () {
      if (this.envType === 'VOD') {
        // 判断是否为测试环境
        if (window.location.href.includes('stage-')) {
          window.open('http://stage-open.cloud.ottcn.com/common/information/1')
        } else {
          window.open('https://open.cloud.ottcn.com/common/information/1')
        }
      } else {
        // 判断是否为测试环境
        if (window.location.href.includes('stage-')) {
          window.open('http://stage-open.cloud.ottcn.com/common/information/2')
        } else {
          window.open('https://open.cloud.ottcn.com/common/information/2')
        }
      }
    },
    goConsole () {
      if (this.envType === 'VOD') {
        if (window.location.href.includes('stage-')) {
          window.location.href = 'http://stage-open.cloud.ottcn.com/console'
          // window.open('http://stage-open.cloud.ottcn.com/console')
        } else {
          window.open('https://open.cloud.ottcn.com/console')
        }
      } else {
        // 判断是否为测试环境
        if (window.location.href.includes('stage-')) {
          window.location.href = 'http://stage-mp.cloud.ottcn.com/console'
          // window.open('http://stage-mp.cloud.ottcn.com/console')
        } else {
          window.open('https://mp.cloud.ottcn.com/console')
        }
      }
    }
  }
}
</script>
<style lang="less">
  @import "../assets/css/layout.less";
  .header-upload {
    text-align: center;
    padding: 10px 0;
    .el-button {
      width: 66%;
    }
  }
</style>
